import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { CreateUpdateTrackmanParameterV2Request } from 'types/admin/trackmanParametersV2';
import { getErrorMessage } from 'utilities/ErrorHelper';
import { adminTrackmanParametersV2QueryKey } from './useTrackmanParametersV2';

export const useUpdateTrackmanParameterV2 = () => {
  const service = useServices().trackmanParametersV2Service;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (request: CreateUpdateTrackmanParameterV2Request) => service.updateParameter(request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: adminTrackmanParametersV2QueryKey });
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
